<template>
  <!-- 新增/编辑 -->
  <el-dialog :title="title ? title : '编辑序号'" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false"
    :append-to-body="appendToBody">
    <el-form ref="form" label-width="80px">
      <el-form-item prop="" ref="form" label-width="80px" label="序号">
        <el-input v-model="sort" placeholder="" clearable style="width: 200px;" maxlength="9"></el-input>
      </el-form-item>
      <el-form-item prop="" ref="form" label-width="70px" label="">
        <el-button type="primary" @click="submit" style="width: 120px; margin-left:10px">确认</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
 
<script>
import {
  recommendShopSortUpdate, recommendGoodsSortUpdate
} from "@/api/recommendationHome";

export default {
  components: {

  },
  props: {
    title: {
      type: String,
      default: '',
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      id: "",
      dialogVisible: false,
      sort: 0,
      type: '',//shop goods 
      flag: false
    };
  },
  computed: {},
  watch: {

  },
  created() { },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  methods: {
    show(row, type) {
      // console.log(row,'---row')
      this.id = row.id;
      this.sort = row.sort;
      this.dialogVisible = true;
      this.type = type;
    },
    submit() {
      if (!this.sort) {
        this.$message.error("请输入序号！");
        return;
      }
      if(!/^[0-9]*$/.test(this.sort)){
        this.$message.error("请输入整数！");
        return;
      }
      if (this.sort < 0) {
        this.$message.error("序号不能小于0！");
        return;
      }
      if (this.flag) {
        return;
      }
      this.flag = true;
      let params = {
        id: this.id,
        sort: this.sort,
      }; 
      // (shop：店铺推荐/热销推荐/限时秒杀/盖楼推荐)
      if (this.type == 'shop') {
        recommendShopSortUpdate(params).then((res) => {
          if (res) {
            this.$message.success("提交成功！");
            this.$emit("refreshList");
            this.dialogVisible = false;
            setTimeout(() => {
              this.flag = false;
            }, 1000);
          } else {
            this.$message.error("提交失败！");
            setTimeout(() => {
              this.flag = false;
            }, 1000);
          }
        }).catch((err) => {
          setTimeout(() => {
              this.flag = false;
            }, 1000);
        })
      }
      // (goods：商品推荐)
      if (this.type == 'goods') {
        recommendGoodsSortUpdate(params).then((res) => {
          if (res) {
            this.$message.success("提交成功！");
            this.$emit("refreshList");
            this.dialogVisible = false;
            setTimeout(() => {
              this.flag = false;
            }, 1000);
          } else {
            this.$message.error("提交失败！");
            setTimeout(() => {
              this.flag = false;
            }, 1000);
          }
        }).catch((err) => {
          setTimeout(() => {
              this.flag = false;
            }, 1000);
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-search {
  display: flex;
  justify-content: space-between;
}
</style>
